import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { AuthService } from '../../core/services/auth.service';
import { TranslatePipe } from '../../core/pipes/translate.pipe';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, TranslatePipe],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent implements OnInit {
  welcomeVisible = false;

  constructor(public auth: AuthService) {}

  ngOnInit(): void {
    this.syncWelcomeBanner();
  }

  private syncWelcomeBanner(): void {
    this.welcomeVisible = this.auth.isAuthenticated && this.auth.shouldShowWelcomeBanner();
  }

  dismissWelcome(): void {
    this.auth.dismissWelcomeBanner();
    this.welcomeVisible = false;
  }
}
